export class LoadAndListenProducts {
  static readonly type = '[Products] Load and Listen Products';
}
